import React from "react";
import { Facebook } from "../../atoms/icons/facebook";
import { Twitter } from "../../atoms/icons/twitter";
import { Email } from "../../atoms/icons/email";
import { WhatsApp } from "../../atoms/icons/whatsapp";
import { Linkedin } from "../../atoms/icons/linkedin";
import { ShareIcon } from "../../atoms/icons/share-icon";
import { CloseIcon } from "../../atoms/icons/close-icon";
import "./styles.m.css";
import { PropTypes } from "prop-types";

export class StickySocialShareTemplate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
    this.toggleClass = this.toggleClass.bind(this);
  }
  toggleClass() {
    const currentState = this.state.open;
    this.setState({ open: !currentState });
  }

  render() {
    const color = global.deviceWidth <= 768 ? "white" : this.props.color;
    const linkedInColor = global.deviceWidth <= 768 ? "white" : "black";
    const { onClick } = this.props;

    return (
      <div styleName="sticky-social-share">
        <ul styleName="sticky-social-share__icons" className={this.state.open ? "open" : null}>
          <li styleName="sticky-social-share__icon sticky-social-share__icon--cta">
            <span onClick={this.toggleClass} styleName="sticky-social-share__toggle-button">
              {this.state.open ? <CloseIcon color={color} /> : <ShareIcon color={color} />}
            </span>
          </li>
          <li styleName="sticky-social-share__icon">
            <a
              onClick={e => onClick(e)}
              data-social-media-type="facebook"
              href={this.props.fbUrl}
              target="_blank"
              rel="noopener noreferrer"
              styleName="sticky-social-share__link"
            >
              <Facebook color={color} />
            </a>
          </li>
          <li styleName="sticky-social-share__icon">
            <a
              onClick={e => onClick(e)}
              data-social-media-type="twitter"
              href={this.props.twitterUrl}
              target="_blank"
              rel="noopener noreferrer"
              styleName="sticky-social-share__link"
            >
              <Twitter color={color} />
            </a>
          </li>
          <li styleName="sticky-social-share__icon">
            <a
              onClick={e => onClick(e)}
              data-social-media-type="linkedin"
              href={this.props.linkedinUrl}
              target="_blank"
              rel="noopener noreferrer"
              styleName="sticky-social-share__link"
            >
              <Linkedin color={linkedInColor} />
            </a>
          </li>
          <li styleName="sticky-social-share__icon">
            <a
              onClick={e => onClick(e)}
              data-social-media-type="mail"
              href={this.props.mailtoUrl}
              styleName="sticky-social-share__link"
            >
              <Email color={color} />
            </a>
          </li>
          <li styleName="sticky-social-share__icon">
            <a
              onClick={e => onClick(e)}
              data-social-media-type="whatsapp"
              href={this.props.whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              styleName="sticky-social-share__link"
            >
              <WhatsApp color={color} />
            </a>
          </li>
        </ul>
      </div>
    );
  }
}

StickySocialShareTemplate.propTypes = {
  color: PropTypes.string,
  twitterUrl: PropTypes.string,
  fbUrl: PropTypes.string,
  linkedinUrl: PropTypes.string,
  gplusUrl: PropTypes.string,
  publisherAttributes: PropTypes.object,
  mailtoUrl: PropTypes.string,
  whatsappUrl: PropTypes.string,
  onClick: PropTypes.func
};
